import App from './App.vue';
import axios from 'axios';
import store from './store';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import VueAxios from 'vue-axios';
import vuetify from './plugins/vuetify';
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import { routes } from './routes';
import { getSavedState } from './utils/localstorage';
import { VueMaskDirective } from 'v-mask';
import VueSanitize from 'vue-sanitize';

Vue.use(VueSanitize);
Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false;

Vue.use(VeeValidate);
Vue.use(VueRouter);
Vue.use(Vuex);
Vue.use(VueAxios, axios);

const router = new VueRouter({
  routes,
  mode: 'history',
  base: process.env.BASE_URL,
});



router.beforeEach((to, from, next) => {
  const isLoggedIn = !!getSavedState('auth.token');

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn) {
      next({ name: 'login' });
    } else {
      next(); // go to wherever I'm going
    }
  } else {
    next(); // does not require auth, make sure to always call next()!
  }
});

export default new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
